import React from 'react'
import HomeScreen from './HomeScreen'
import Layout from '../../components/layout/Layout'

const HomePage = () => {
  return (
    <>
   <Layout>
    <HomeScreen />
   </Layout>
    </>
  )
}

export default HomePage
